import { ColumnDefaults, Columns } from '#types/grid';

export function setColumnDefaults(columns: Columns, defaults: ColumnDefaults): Columns {
  defaults.filterable = defaults.filterable ?? false;
  defaults.sort = defaults.sort ?? null;
  defaults.sortable = defaults.sortable ?? true;
  defaults.sortOrder = defaults.sortOrder ?? null;
  defaults.type = defaults.type ?? 'string';
  defaults.visible = defaults.visible ?? true;
  defaults.width = defaults.width ?? 200;
  defaults.align = defaults.align ?? 'left';
  defaults.canToggleVisibility = defaults.canToggleVisibility ?? true;
  defaults.editable = defaults.editable ?? false;
  defaults.editOptions = defaults.editOptions ?? {};

  for (const col of columns) {
    if (!col.hasOwnProperty('header')) {
      col.header = col.field;
    }

    if (!col.hasOwnProperty('width')) {
      col.width = defaults.width;
    }

    if (!col.hasOwnProperty('sortable')) {
      col.sortable = defaults.sortable;
    }

    if (!col.hasOwnProperty('sort')) {
      col.sort = defaults.sort;
    }

    if (!col.hasOwnProperty('sortOrder')) {
      col.sortOrder = defaults.sortOrder;
    }

    if (!col.hasOwnProperty('filterable')) {
      col.filterable = defaults.filterable;
    }

    if (!col.hasOwnProperty('editable')) {
      col.editable = defaults.editable;
    }

    if (!col.hasOwnProperty('editOptions')) {
      col.editOptions = defaults.editOptions;
    }

    if (!col.hasOwnProperty('visible')) {
      col.visible = defaults.visible;
    }

    if (!col.hasOwnProperty('type')) {
      if (col.formatter && ['money', 'decimal', 'number'].includes(col.formatter)) {
        col.type = 'number';
      } else {
        col.type = defaults.type;
      }
    }

    if (!col.hasOwnProperty('align')) {
      if (col.formatter && ['money', 'decimal'].includes(col.formatter)) {
        col.align = 'right';
      } else {
        col.align = defaults.align;
      }
    }

    if (!col.hasOwnProperty('headerAlign')) {
      col.headerAlign = defaults.align;
    }

    if (!col.hasOwnProperty('footerAlign')) {
      col.footerAlign = 'right';
    }

    if (!col.hasOwnProperty('canToggleVisibility')) {
      col.canToggleVisibility = defaults.canToggleVisibility;
    }
  }

  return [...columns];
}
